import RangesList from "./RangesList";

export default RangesList;
